export default __webpack_public_path__ + "static/1033-169607a0a020e60b6ef028b859bb429d.gif";